import helper from "./helper";
// import user from "../store/modules/user";

let getSurveyUrl = helper.getSurveyUrlWithParameters

export default {
    getSurveyUrl,
    getByRecievedUrlData:
      /**
       * Получает URL на основе полученных данных
       * @param {Object} url - Объект с данными URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL
       */
      (url, gets = null) => getSurveyUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    COHERENT:
      /**
       * Получает URL для работы с последовательностей
       * @param {number} coherent_number - Номер в последовательности
       * @param {Object} gets - Query-параметры
       * @returns {string} URL для операций с последовательностями
       */
      (coherent_number, gets = null) => getSurveyUrl(
      'coherent',
      "get",
      {
        coherent_number
      },
      gets
    ),

}
